import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=7ecf6ced&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ecf6ced')) {
      api.createRecord('7ecf6ced', component.options)
    } else {
      api.reload('7ecf6ced', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=7ecf6ced&", function () {
      api.rerender('7ecf6ced', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2cCBq56XRy6oY/JS/comp/IncreaseNumber.vue"
export default component.exports